<template>
  <div class="product-form product-form--basic-info row">
    <div class="col-24">
      <div class="row">
        <div class="col-24 col-xl-8">
          <div class="product-form__input-wrap">
            <div class="product-form__title">Czy posiada warianty?</div>
            <label
              :for="'check-have_variants-' + product.id"
              class="product-form__checkbox"
            >
              <input
                :id="'check-have_variants-' + product.id"
                class="product-form__checkbox--input"
                type="checkbox"
                v-model="product.have_variants"
                @change="haveVariantsChange(), $root.$emit('productIsChanged')"
              />
              <span
                class="product-form__checkbox-checkmark"
                v-text="product.have_variants ? 'Tak' : 'Nie'"
              ></span>
            </label>
          </div>
        </div>
      </div>
      <div v-if="product.have_variants">
        <draggable
          v-model="product.variants"
          @change="changeOrder(), $root.$emit('productIsChanged')"
        >
          <div v-for="(variant, index) in product.variants" :key="variant.id">
            <VariantItem
              :variant="variant"
              :index="index"
              :dictionaries="dictionaries"
              @deleteVariant="deleteVariant"
            ></VariantItem>
          </div>
        </draggable>

        <button
            v-if="this.variantCount < this.variantLimit"
          class="button button--icon"
          @click="addVariant(), $root.$emit('productIsChanged')"
        >
          <icon
            icon="plus"
            icon-classes="button__icon button__icon--left icon--white icon__plus--small"
          />
          <span class="button__text">Dodaj wariant</span>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import Icon from "../parts/Icon";
import VariantItem from "./VariantItem.vue";
import draggable from "vuedraggable";

export default {
  data() {
    return {
      variantCount: 0,
      variantLimit: 1000
    };
  },
  props: {
    product: {
      type: Object,
      required: false,
    },
    dictionaries: {
      type: Object,
      required: true,
    },
    variant_attributes: {
      type: Array,
      require: false,
    },
  },
  components: { Icon, VariantItem, draggable },
  mounted() {

      this.variantCount = this.product.variants.length;

    this.$root.$on("saveProduct", () => {
      this.storeProduct();
    });

  },
  beforeDestroy() {
    this.$root.$off("saveProduct");
  },
  methods: {
    changeOrder() {
      this.product.variants.forEach((content, index) => {
        content["order"] = index + 1;
      });
    },
    addVariant() {
      var variantAttributes = [...this.variant_attributes];
      variantAttributes.forEach((attribute) => {
        attribute.option_value_string = null;
        attribute.product_option_id = null;
        attribute.option_value_boolean = false;
        attribute.spim_category_id = this.product.spim_category_id;
      });
      this.variantCount++

      var variant = {
        id: null,
        universal_color: false,
        product_id: this.product.id,
        index: null,
        ean13: null,
        is_acctive: 0,
        is_new: 0,
        length: null,
        width: null,
        height: null,
        weight: null,
        packaging_id: null,
        packaging_material: null,
        //translate
        name: null,
        attributes: variantAttributes,
        gallery: [],
        main_photo: { id: null, path: null, type: "main_photo" },
        packaging_photos: [],
        arrangement_photos: [],
        set_products: [],
        order: this.product.variants.length + 1,
      };
      this.product.variants.push(variant);
      this.changeOrder();
    },
    deleteVariant(index) {
      this.variantCount--
      this.product.variants.splice(index, 1);
      this.changeOrder();
    },
    haveVariantsChange() {
      if (!this.product.have_variants) {
        this.product.variants = [];

        //add new attributes
        this.product.attributes = this.product.attributes.concat(
          this.variant_attributes
        );

        this.product.attributes.sort((a, b) =>
          a.pivot.order > b.pivot.order ? 1 : -1
        );
      } else {
        this.product.attributes = this.product.attributes.filter(
          (attribute) => {
            return attribute.show_in_variants == 0;
          }
        );
      }
    },
  },
};
</script>
